module.exports = __webpack_public_path__ + "static/media/ninja_back_V5.b1eb1aa0.jpg";